import { Vector2 } from "api/types/sketch";
import { Bump } from "api/types/sketch";
import { OrderBump } from "api/types/order/order";
import { SelfOrderBump } from "api/types/order/self_order";
import { drawFullWidth } from "../";
import { drawBumpIn } from "../";
import { drawBumpOut } from "../";
import { drawBumpInArc } from "../";
import { drawBumpOutArc } from "../";
import { NO_BUMP } from "values/values";
import { BUMP_IN } from "values/values";
import { BUMP_OUT } from "values/values";
import { BUMP_IN_ARC } from "values/values";
import { BUMP_OUT_ARC } from "values/values";
import { FULL_ARC } from "values/values";

export function drawBumps(
  path: Path2D,
  edge_path: Path2D,
  unsorted_bumps: Bump[] | OrderBump[] | SelfOrderBump[],
  current_location: Vector2,
  next_location: Vector2,
  angle: number,
  zoom: number,
  needs_edge: boolean
) {
  let is_full_arc: boolean = false;
  const bumps: Bump[] | OrderBump[] | SelfOrderBump[] = [...unsorted_bumps];
  bumps.sort(function (a, b) {
    if (a.distance < b.distance) {
      return -1;
    }
    else if (a.distance > b.distance) {
      return 1;
    }
    else {
      return 0;
    }
  });

  for (let j = 0; j < bumps.length; j++) {
    if (bumps[j].bump_type === FULL_ARC) {
      is_full_arc = true;
      drawFullWidth(
        path,
        edge_path,
        current_location,
        next_location,
        bumps[j].depth,
        angle,
        zoom,
        needs_edge
      );
    }
  }

  if (!is_full_arc) {
    for (let j = 0; j < bumps.length; j++) {
      if (bumps[j].bump_type === NO_BUMP) {
        continue;
      }
      else if (bumps[j].bump_type === BUMP_IN) {
        drawBumpIn(
          path,
          edge_path,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          bumps[j].left_side_angle,
          bumps[j].right_side_angle,
          zoom,
          needs_edge
        );
      }
      else if (bumps[j].bump_type === BUMP_OUT) {
        drawBumpOut(
          path,
          edge_path,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          bumps[j].left_side_angle,
          bumps[j].right_side_angle,
          zoom,
          needs_edge
        );
      }
      else if (bumps[j].bump_type === BUMP_IN_ARC) {
        drawBumpInArc(
          path,
          edge_path,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          zoom,
          needs_edge
        );
      }
      else if (bumps[j].bump_type === BUMP_OUT_ARC) {
        drawBumpOutArc(
          path,
          edge_path,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          zoom,
          needs_edge
        );
      }
    }
  }
}
